/* ==========================================================================
   LIGHT + GLO — Premium Mega Menu behaviour
   Hover-intent on desktop, click on touch, full keyboard + escape support.
   ========================================================================== */
(function () {
  const HOVER_OPEN_DELAY = 60;
  const HOVER_CLOSE_DELAY = 220;

  const items = document.querySelectorAll('[data-mega-item]');
  let closeTimer = null;
  let openTimer = null;

  function isTouchDevice() {
    return window.matchMedia('(hover: none)').matches;
  }

  function closeAll(except) {
    items.forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function openItem(item) {
    closeAll(item);
    item.classList.add('is-open');
    const trigger = item.querySelector('[data-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    const trigger = item.querySelector('[data-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  items.forEach((item) => {
    const trigger = item.querySelector('[data-mega-trigger]');
    if (!trigger) return;

    // Click / tap — used on touch devices and for keyboard activation
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');
      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    });

    if (!isTouchDevice()) {
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(() => openItem(item), HOVER_OPEN_DELAY);
      });

      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => closeItem(item), HOVER_CLOSE_DELAY);
      });
    }
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    const clickedInsideNav = e.target.closest('[data-mega-item]');
    if (!clickedInsideNav) closeAll();
  });

  // Close on Escape, return focus to the trigger
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openItem = document.querySelector('[data-mega-item].is-open');
      if (openItem) {
        closeItem(openItem);
        const trigger = openItem.querySelector('[data-mega-trigger]');
        if (trigger) trigger.focus();
      }
    }
  });

  // Mobile toggle — hook this up to whatever mobile drawer you already have,
  // or extend this to slide in a full-screen nav using the same markup.
  const mobileToggle = document.querySelector('[data-mega-mobile-toggle]');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      document.body.classList.toggle('mega-nav-mobile-open');
    });
  }
})();
